import { TQuerySalesOrder } from '@src/modules/sales-order'

import { request } from './config'

export const getListSalesOrder = (params: TQuerySalesOrder, token: string) =>
  request({ url: 'sales-order', method: 'GET', params }, { token })
